import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { TYPE_SUCCESS } from '../../constants/snackbar';

import { getMainPlayerWidget } from '../../components/Player/helpers';
import { gqlRequest } from '../../helpers/request';
import { notifyAction } from '../slices/snackbar';
import { sendShareAction } from '../slices/teamShare';

const queryGQL = `
  mutation hostedWatchSendShare(
    $userIds: [Int],
    $time: Int,
    $message: String,
    $videoId: String,
    $url: String,
  ) {
    hostedWatchSendShare(
      userIds: $userIds,
      time: $time,
      message: $message,
      videoId: $videoId,
      url: $url,
    ) {
      message
    }
  }
`;

export default (action$) =>
  action$.pipe(
    ofType(sendShareAction.type),
    switchMap(({ payload }) => {
      const { users, time, message, videoId, link } = payload;

      const queryParams = {
        userIds: users.map((user) => user.id),
        videoId,
        url: link,
      };

      if (time) {
        queryParams.time = time;
      }
      if (message) {
        queryParams.message = message;
      }

      return gqlRequest({
        query: queryGQL,
        variables: queryParams,
      }).pipe(
        map(({ errors }) => {
          if (!errors.length) {
            const LWP = getMainPlayerWidget();
            LWP.sendStatsAddShare(time || 0, message?.length || 0, users.length);
            return notifyAction({ variant: TYPE_SUCCESS, message: 'Video shared' });
          }

          return EMPTY;
        }),
      );
    }),
  );
